import React from 'react';
import { FormikProps } from 'formik';
import { KeyMatch } from '../../../types';

interface Props<T> extends FormikProps<T> {
  name: KeyMatch<T, string | null>;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
}

const InputWrap = <T extends object>(props: Props<T>) => {
  const { name, type, placeholder, disabled, values, touched, errors, handleChange, handleBlur } =
    props;
  const hasError = touched[name] && errors[name];

  const value = values[name] === null ? '' : String(values[name]); // almost perfect. ideally cast shouldn't be needed

  return (
    <div className="form__form-group-input-wrap">
      {type !== 'textarea' ? (
        <input
          name={name}
          className={hasError && 'error'}
          placeholder={placeholder}
          type={type || 'text'}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={disabled}
          formNoValidate={disabled}
        />
      ) : (
        <textarea
          name={name}
          className={hasError && 'error'}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={disabled}
        />
      )}
      {hasError && <span className="form__form-group-error">{errors[name] as string}</span>}
    </div>
  );
};

export default InputWrap;
